import { useContext } from "react";
import { ReportContext } from "common/providers/ReportProvider";

export const useReport = () => useContext(ReportContext);

export default useReport;
